import { PERCENTAGE_ENUM } from '@/enums/percentage.enum'

const SPLIT_ENUM = {
  ALL: 'ALL'
}

const SPLIT_TYPE_ENUM = {
  FLAT: { key: 'flat', values: ['flat'] },
  PERCENTAGE: { key: 'percentage', values: PERCENTAGE_ENUM }
}

const isAllTypeSplit = value =>
  Array.isArray(value) || value.toLowerCase() === SPLIT_ENUM.ALL.toLowerCase()

const isSplitTypeFlat = value =>
  SPLIT_TYPE_ENUM.FLAT.values.includes(value.toLowerCase())

const isSplitTypePercentage = value =>
  SPLIT_TYPE_ENUM.PERCENTAGE.values.includes(value.toLowerCase())

export {
  SPLIT_ENUM,
  SPLIT_TYPE_ENUM,
  isSplitTypeFlat,
  isSplitTypePercentage,
  isAllTypeSplit
}
